<template>
  <div style="position: relative;">
    <v-progress-linear v-if="loading" style="position: absolute;" class="ma-0" indeterminate color="info" />
    <div v-if="!errorModal">
      <v-alert :type="alertType" class="ma-0" outline icon="priority_high" :value="hasError">
        <div class="primary--text" v-html="errorHtml" />
        <div class="primary--text" v-show="!errorHtml">
          <span v-for="(item, index) in noDataNameArr" :key="index" :style="{color:item.color}">{{ item.name }}
            <span v-if="index!=noDataNameArr.length-1">,&nbsp;</span>
          </span>
          <span>{{ infoHtml }}</span>
        </div>
      </v-alert>
      <div :id="id" v-show="!errorHtml" />      
    </div>

    <ChartErrorModal v-model="errorModal" :data="errorModalData" @cancel="onErrorModalClose"  />
  </div>
</template>

<script>
  import Highcharts from 'highcharts'
  import 'highcharts/modules/exporting'
  import 'highcharts/modules/offline-exporting'
  import DataCharts from '@/components/mixins/DataCharts'
  import MomentUtil from '@/components/mixins/MomentUtil'
  import { newDateStringNoTimezone } from '@/components/mixins/MomentUtil'
  import axios from 'axios'
  import moment from 'moment'
  const { mapGetters } = createNamespacedHelpers('imports')
  import { createNamespacedHelpers } from 'vuex'
  import ChartErrorModal from '@/components/generic/ChartErrorModal'

  /* eslint-disable */
  // needed for internet explorer
  import classList from '@/classList'
  /* eslint-enable */


  export default {
    components: {
      ChartErrorModal,
    },
    mixins: [DataCharts, MomentUtil],
    props: ['requestData'],
    data() {
      return {
        loading: false,
        hasError: false,
        errorHtml: null,
        infoHtml: null,
        rawGraphData: [],
        graphShown: false,
        alertType: 'error',
        alertColor: 'error',
        isShowTooltip: false,
        clone_container: null,
        clone_tooltip: null,
        noDataNameArr: [],
        errorModal: false,
        errorModalData: {},
      }
    },
    mounted() {},
    computed: {
      ...mapGetters(['importlist']),
      timeRange() {
        if (this.requestData != null) {
          return [this.requestData.startDate, this.requestData.endDate]
        }
      },
    },
    watch: {
      requestData() {
        this.loading = true
        this.graphShown = true
        this.generateChart()
      },
    },
    methods: {
      constructArgumentForSingleDataset(dataset, index, oppositeYAxis) {
        var timeSeriesColor = Highcharts.getOptions().colors[index % 10]
        var dataSetConfig = {
          name: dataset.Analyte,
          type: 'line',
          yAxis: index,
          color: timeSeriesColor,
        }
        var yAxisConfig = { // Primary yAxis
          labels: {
            format: '',
            style: {
              color: timeSeriesColor,
            },
          },
          title: {
            text: dataset.Analyte + ' (' + dataset.Unit + ')',
            style: {
              color: timeSeriesColor,
            },
          },
          opposite: oppositeYAxis,
        }

        return {
          dataset: dataSetConfig,
          yAxis: yAxisConfig,
        }
      },
      constructGraphingArguments() {
        var counter = -1
        var datasets = []
        var yAxis = []
        var opposite = true
        for (var i = 0; i < this.requestData.datasets.length; i++) {
          var matchedDataset = this.requestData.datasets[i]
          if (matchedDataset != null) {
            counter++
            var config = this.constructArgumentForSingleDataset(matchedDataset, counter, opposite)
            datasets.push(config.dataset)
            yAxis.push(config.yAxis)
            opposite = !opposite
          }
        }
        if (counter >= 0) {
          // find the latest time range        
          var graphingArguments = {
            title: '',
            timeRange: this.timeRange,
            datasets: datasets,
            yAxis: yAxis,
          }
          return graphingArguments
        }
        return null
      },
      async fetchGraphData(datasetsArgs, requestData) {
        var data = []
        var url = 'api/WaterQuality/FetchDashboardGraphData'
        await axios.post(url, requestData).then((res) => {
          this.noDataNameArr = []
          this.rawGraphData = res.data.AnalytesData
          for (var i = 0; i < datasetsArgs.length; i++) {
            var index = res.data.AnalytesData.findIndex(y => datasetsArgs[i].name == y.AnalyteName)
            var serieData = index == -1 ? null : res.data.AnalytesData[index]
            if (serieData) {
              var detectionLimits = serieData.Points.map(x => x.DetectionLimit)
              var comments = serieData.Points.map(x => x.Comment)
              let yAxisIndex = datasetsArgs.findIndex(y => y.name === serieData.AnalyteName)
              let yAxisArg = datasetsArgs[yAxisIndex]
              var rows = serieData.Points.map(x => [moment(x.DateTime).valueOf(), x.Value])
              var self = this
              for (var j = 0; j < rows.length; j++) {
                if (detectionLimits && detectionLimits[j]) {
                  var precision = self.getPrecisionByFloat(detectionLimits[j], 20)
                  if (!self.floatGreaterThan(rows[j][1], detectionLimits[j], precision)) {
                    rows[j] = {
                      x: rows[j][0],
                      y: rows[j][1],
                      marker: {
                        fillColor: '#FFFFFF',
                        lineWidth: 2,
                        lineColor: yAxisArg.color,
                      },
                    }
                  }
                }
              }
              var guidelineData = this.mapGuidelineData(
                res.data.StandardData,
                serieData.AnalyteName,
                yAxisIndex,
                yAxisArg.type,
                serieData.Unit,
                yAxisArg.color
              )
              if (guidelineData != null) {
                data.push(guidelineData)
              }
              data.push({
                name: serieData.AnalyteName,
                data: rows,
                detectionLimits: detectionLimits,
                comments: comments,
                yAxis: yAxisIndex,
                type: yAxisArg.type,
                unit: serieData.Unit,
                color: yAxisArg.color,
              })
            } else {
              this.noDataNameArr.push({
                name: datasetsArgs[i].name,
                color: datasetsArgs[i].color,
              })
              data.push({
                name: datasetsArgs[i].name,
                data: [],
                detectionLimits: [],
                comments: [],
                yAxis: datasetsArgs[i].yAxis,
                type: datasetsArgs[i].type,
                unit: '',
                color: datasetsArgs[i].color,
              })
            }
          }
        }).catch(error => {
          this.errorModal = true
          this.errorModalData = error.response.data
        })
        return data
      },
      onErrorModalClose() {
        this.errorModal = false
        this.errorModalData = {}
      },
      mapGuidelineData(allData, analyteName, yAxis, type, unit, color) {
        var matchedGuidelineData = allData.find(x => x.AnalyteName === analyteName)
        if (matchedGuidelineData != null) {
          var data = {
            name: analyteName + ' Guideline: ' + matchedGuidelineData.GuidelineName,
            yAxis: yAxis,
            unit: unit,
            color: color,
            type: type === 'line' ? 'line' : 'arearange',
            dashStyle: 'Dash',
            fillOpacity: 0.3,
            data: matchedGuidelineData.StandardValuePoints.map(x => {
              if (type === 'line') {
                return [moment(x.DateTime).valueOf(), x.Value]
              } else {
                return [moment(x.DateTime).valueOf(), x.Min, x.Max]
              }
            }),
          }
          return data
        }
        return null
      },
      drawChartWithArgsIncludeCOC(args, data) {
        var self = this
        var globalYAxisMin = 0
        var globalYAxisMaxPerUnit = {}

        for (var j = 0; j < data.length; j++) {
          if (!globalYAxisMaxPerUnit[data[j].unit]) {
            globalYAxisMaxPerUnit[data[j].unit] = 0
          }
          var index = data[j].yAxis
          args.yAxis[index].title.text = data[j].name + ' ' + data[j].unit

          let yAxisMinForSeries = Math.min.apply(Math, data[index].data.map(function(i) {
            if (isNaN(i[1])) {
              return i.y
            } else {
              return i[1]
            }
          }))
          globalYAxisMin = Math.min(globalYAxisMin, yAxisMinForSeries)

          let yAxisMax = Math.max.apply(Math, data[j].data.map(function(i) {
            if (isNaN(i[1])) {
              return i.y
            } else {
              return i[1]
            }
          }))

          if (yAxisMax > globalYAxisMaxPerUnit[data[j].unit]) {
            globalYAxisMaxPerUnit[data[j].unit] = yAxisMax
          }
        }

        for (var i = 0; i < data.length; i++) {
          var idx = data[i].yAxis
          args.yAxis[idx].max = globalYAxisMaxPerUnit[data[i].unit]
          args.yAxis[idx].min = globalYAxisMin
        }

        Highcharts.setOptions({
          time: {
            useUTC: false,
          },
        })

        this.highchartsOptions = {
          chart: {
            renderTo: this.id,
            zoomType: 'xy',
            panning: true,
            panKey: 'shift',
            resetZoomButton: {
              position: {
                align: 'right',
                verticalAlign: 'top',
                x: -160,
              },
              relativeTo: 'chart',
              theme: {
                fill: 'white',
                stroke: 'silver',
                padding: 3,
              },
            },
            events: {
              load: function() {
                var label = this.renderer.label('Hollow symbols represent values below detection limits and ' +
                    'solid symbols represent values above detection limits.')
                  .css({
                    width: '600px',
                    fontSize: '10px',
                  })
                  .attr({
                    'stroke': 'silver',
                    'stroke-width': 1,
                    'r': 2,
                    'padding': 5,
                  })
                  .add()

                label.align(Highcharts.extend(label.getBBox(), {
                  align: 'center',
                  x: 0, // offset
                  verticalAlign: 'bottom',
                  y: 0, // offset
                }), null, 'spacingBox')
              },
              click: function() {
                var chart = this
                self.clean_tooltip(chart)
              },
            },
            marginBottom: 120,
          },
          credits: {
            enabled: false,
          },
          tooltip: {
            useHTML: true,
            valueDecimals: 3,
            style: {
              pointerEvents: 'auto',
            },
            formatter: function() {
              if (!self.isShowTooltip) {
                return false
              }
              var precision = self.getPrecisionByFloat(this.y, 3)
              return '<b>' + this.series.name + '</b><br/>' +
                Highcharts.dateFormat('%b. %e, %Y %H:%M', this.x) + ' ' + this.y.toFixed(precision) + ' ' + this.series.options.unit + '<br/>' +
                self.getDetectionLimit(this.point.index, this.series, data) + this.series.options.unit + '<br/>' +                
                self.getImportByCocCode(this.point.index, this.series.name) + '<br/>' +
                self.getComment(this.point.index, this.series, data) + '<br/>'
              // 'COC Code:<a href="' + self.getImportByCocCode(this.point.index, this.series.name) + '">link</a>' + '<b>' + 'COC Code' + '</b>' 
            },
            hideDelay: 50,
          },
          title: {
            text: args.title,
          },
          legend: {
            useHTML: true,
            align: 'center',
            verticalAlign: 'top',
            layout: 'horizontal',
            labelFormatter: function () {
              return '<span style="display: inline-block; max-width: 180px; overflow-wrap: break-word; word-wrap: break-word; white-space: normal; vertical-align: middle;">' + this.name + '</span>'
            },
          },
          subtitle: {
            text: 'Click on points to view details.  Click and drag to zoom in. Hold down shift key to pan.',
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: { // don't display the dummy year
              day: '%b. %e',
              month: '%b. %Y',
              year: '%Y',
            },
          },
          yAxis: args.yAxis,
          plotOptions: {
            series: {
              stickyTracking: false,
              events: {
                click: function() {

                  self.isShowTooltip = true
                  self.clean_tooltip(this.chart)

                  var root_elem = document.getElementById('waterqualitystationChart')
                  var hc_tooltip = root_elem.getElementsByClassName('highcharts-tooltip')
                  var orig_container = hc_tooltip[0]
                  var orig_tooltip = hc_tooltip[1]

                  if (!orig_container || !orig_tooltip) {
                    return
                  }

                  self.clone_tooltip = orig_tooltip.cloneNode(true)
                  self.clone_tooltip.classList.remove('invisible_highcharttooltip')
                  self.clone_tooltip.classList.add('clone')

                  self.clone_container = this.chart.tooltip.label.element.cloneNode(true)
                  self.clone_container.classList.remove('invisible_highcharttooltip')
                  self.clone_container.classList.add('clone')

                  this.chart.container.firstChild.appendChild(self.clone_container)
                  this.chart.container.appendChild(self.clone_tooltip)
                },
                mouseOver: function() {
                  var root_elem = document.getElementById('waterqualitystationChart')
                  var orig_tooltip, orig_container
                  var hc_tooltip = root_elem.getElementsByClassName('highcharts-tooltip')

                  orig_container = hc_tooltip[0]
                  orig_tooltip = hc_tooltip[1]

                  if (orig_container && !self.hasClass(orig_container, 'clone')) {
                    orig_container.classList.add('invisible_highcharttooltip')
                  }

                  if (orig_tooltip && !self.hasClass(orig_tooltip, 'clone')) {
                    orig_tooltip.classList.add('invisible_highcharttooltip')
                  }
                },
                hide: function() {
                  let globalYAxisMaxPerUnit = self.computeMaxForVisibleSeriesInChart(data)
                  self.setExtremesForVisibleSeriesInChart(data, globalYAxisMaxPerUnit, null)
                },
                show: function() {
                  let globalYAxisMaxPerUnit = self.computeMaxForVisibleSeriesInChart(data)
                  self.setExtremesForVisibleSeriesInChart(data, globalYAxisMaxPerUnit, null)
                },
              },
              marker: {
                enabled: true,
              },
            },
          },
          series: data,
          exporting: this.makeExportingConfig(),
        }
        /* eslint-disable */
        this.chart = new Highcharts.chart(this.highchartsOptions)
        /* eslint-enable */
      },
      hasClass(element, cls) {
        return element.classList.contains(cls)
      },
      clean_tooltip(chart) {
        if (this.clone_container) {
          chart.container.firstChild.removeChild(this.clone_container)
          this.clone_container = null
        }

        if (this.clone_tooltip) {
          chart.container.removeChild(this.clone_tooltip)
          this.clone_tooltip = null
        }
      },


      getImportByCocCode(pointIndex, name) {
        var foundGraphData = this.rawGraphData.find(x => x.AnalyteName == name)
        if (foundGraphData) {
          var matchedPoint = foundGraphData.Points[pointIndex]
        } else {
          var htmlGuideline = '<b><a target="_blank"></a></b>'
          return htmlGuideline
        }
        var cocCode = matchedPoint.CocCode
        if (cocCode == null) {
          return 'COC Code: <b>Unknown</b>'
        } else {
          var matchedImport = null
          if (matchedPoint.ImportId != null) {
            matchedImport = this.importlist.find(x => x.id == matchedPoint.ImportId)
          } else {
            matchedImport = this.importlist.find(x => x.coc_code == cocCode)
          }
          if (matchedImport == null) {
            return 'COC Code: <b>Unknown</b>'
          }
          var importLink = this.$router.resolve(`/import/${matchedPoint.ImportId}`).href
          var html = `COC Code: <b>${matchedImport.coc_code}</b><br/><a href='${importLink}'>Import Detail</a> | <a href='/uploads/${matchedImport.filename}'>Source File</a>`

          var samples = this.$store.getters['sampleactivity/samples']
          var documents = [].concat.apply([], samples.filter(x => x.cocCode == cocCode).map(x => x.documents))

          if (documents.length > 0) {
            var firstDocument = documents[0]
            html += ` | <a target="blank" href="/uploads/${firstDocument.fileName}">Sample Document</a>`
          }

          return html
          //return 'COC Code: <b><a target="_blank">' + cocCode + '</a></b>'
        }
      },
      getDetectionLimit(pointIndex, series, data) {
        var dataSeries = data.filter(x => x.name == series.name)[0]
        if (!dataSeries || !dataSeries.detectionLimits || !dataSeries.detectionLimits[pointIndex]) {
          return 'Detection Limit: Unknown '
        }
        var detectionLimit = dataSeries.detectionLimits[pointIndex]
        var precision = this.getPrecisionByFloat(detectionLimit, 3)

        var html = `Detection Limit: ${detectionLimit.toFixed(precision)} `

        return html
      },
      getComment(pointIndex, series, data) {
        var dataSeries = data.filter(x => x.name == series.name)[0]
        if (!dataSeries || !dataSeries.comments || !dataSeries.comments[pointIndex]) {
          return 'Comment: Unknown '
        }
        var comment = dataSeries.comments[pointIndex]
        var html = `Comment: ${comment} `
        
        return html
      },

      generateChart() {
        this.clean_tooltip(this.chart)
        if (this.requestData.datasets != undefined) {
          this.hasError = false
          if (this.requestData.datasets.length > 5) {
            this.alertType = 'warning'
            this.loading = false
            this.hasError = true
            this.errorHtml = 'Select at most 5 analytes for the graph'
            return
          }
          try {
            var args = this.constructGraphingArguments()
            var requestData = {
              StartDate: newDateStringNoTimezone(args.timeRange[0]),
              EndDate: newDateStringNoTimezone(args.timeRange[1]),
              IncludeDischargeData: false,
              StationName: this.requestData.stationName,
              WaterQualityStandards: this.requestData.guidelines[0] ? this.requestData.guidelines : [],
              WaterQualityDatasets: this.requestData.datasets,
              Media: this.requestData.media,
              IncludeQaQc: this.requestData.includeQaQc,
            }
            this.fetchGraphData(args.datasets, requestData).then(wqData => {
              this.errorHtml = null
              this.hasError = false
              this.loading = false
              if (this.rawGraphData.length == 0) {
                var analyteNameArray = []
                this.requestData.datasets.forEach(element => {
                  analyteNameArray.push(element.Analyte)
                })
                var analyteName = analyteNameArray.join(', ')
                this.alertType = 'warning'
                this.errorHtml = `Sorry, there is no data for ${analyteName} for the selected date range`
                this.hasError = true
                this.loading = false
              } else if (this.rawGraphData.length != args.datasets.length) {
                this.alertType = 'warning'
                this.hasError = true
                this.infoHtml = this.noDataNameArr.length == 1 ? 'does not have data for the selected time range' : 'do not have data for the selected time range'
                this.loading = false
              }
              try {
                this.drawChartWithArgsIncludeCOC(args, wqData)
              } catch (e) {
                this.alertType = 'error'
                this.hasError = true
                this.loading = false
                this.$jsnLog().error((e && e.toString()) || '')
                //console.error(e)
                this.errorHtml = 'Oops, we couldn\'t plot the graph data. Please try again.'
              }
            }).catch((e) => {
              this.alertType = 'error'
              this.hasError = true
              this.loading = false
              this.$jsnLog().error((e && e.toString()) || '')
              this.errorHtml = 'Uh oh. We couldn\'t fetch the graph data. Please try in a bit.'
            })
          } catch (e) {
            this.alertType = 'error'
            this.hasError = true
            this.loading = false
            this.$jsnLog().error((e && e.toString()) || '')
            this.errorHtml = 'Oops, something\'s off with the data format. Please let us know so we can fix it.'
          }
        }
      },
    },
  }
</script>
<style>
  .invisible_highcharttooltip {
    visibility: hidden !important;
  }
</style>